import Vue from "vue";
import Main from "./index.vue";

/**
 * 使用extend方法生成constructor动态创建组件
 */
const MessageBoxConstructor = Vue.extend(Main);

const showMsg = options => {
  const instance = new MessageBoxConstructor({
    data: options
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  instance.visibleData = true;
  return instance;
};

/**
 * 有alert，confirm，prompt三种方法，给组件传入不同的初值
 * @param {string|object} message - 为String时，作为MessageBox显示的内容，为Object时，作为MessageBox的data选项
 * @param {string} title - MessageBox的标题
 * @param {object} options - 传入MessageBox的data选项
 */
const MessageBox = {
  alert: (message = "", title = "", options = {}) => {
    if (typeof message === "object") {
      return showMsg(
        Object.assign(
          {
            type: "alert"
          },
          message
        )
      );
    }
    return showMsg(
      Object.assign(
        {
          title,
          message,
          type: "alert"
        },
        options
      )
    );
  },
  confirm: (message = "", title = "", options = {}) =>
    new Promise((resolve, reject) => {
      if (typeof message === "object") {
        showMsg(
          Object.assign(
            {
              type: "confirm",
              showHeader: false,
              resolve,
              reject
            },
            message
          )
        );
      } else {
        showMsg(
          Object.assign(
            {
              title,
              message,
              type: "confirm",
              showHeader: false,
              resolve,
              reject
            },
            options
          )
        );
      }
    }),

  prompt: (message = "", title = "", options = {}) =>
    new Promise((resolve, reject) => {
      if (typeof message === "object") {
        showMsg(
          Object.assign(
            {
              type: "prompt",
              showHeader: false,
              resolve,
              reject
            },
            message
          )
        );
      } else {
        showMsg(
          Object.assign(
            {
              title,
              message,
              type: "prompt",
              showHeader: false,
              resolve,
              reject
            },
            options
          )
        );
      }
    })
};

export default MessageBox;
